import { LabelRegular } from "@hm/fundamental"
import { imprint } from "@shared/routes"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export const UserMenuFooter: React.FC = () => {
	const { t } = useTranslation("features", {
		keyPrefix: "userMenu",
	})

	return (
		<div className="flex flex-col items-center" data-cy="user-menu-footer">
			<LabelRegular className="text-foreground_faded">
				{t("copyright")}
			</LabelRegular>
			<LabelRegular className="text-foreground_faded">
				<Link
					className="underline"
					to={imprint}
					data-cy="user-menu-imprint-link"
				>
					{t("impressum")}
				</Link>
			</LabelRegular>
		</div>
	)
}
